import {
  ERROR_CSV,
  FETCHING_CSV,
  RECEIVE_CSV,
  CLEAR_ERROR_OR_DATA,
  INITIATED_EXPORT_PARTICIPANT_ARCHIVE,
  RESET_INITIATED_EXPORT_PARTICIPANT_ARCHIVE,
  GET_EXPORT_ARCHIVE_STATUS,
  GET_EXPORT_ARCHIVE_STATUS_ERROR
} from '../actions/actionTypes';

const reportsInit = {
  isFetching: false,
  objectBlob: null,
  error: null,
  topic: null,
  initiatedParticipantExport: false,
  exportStudy: null,
  newDataAvailableForExport: null
};

const reportsReducer = (state = reportsInit, action) => {
  switch (action.type) {
    case FETCHING_CSV:
      return Object.assign({}, state, reportsInit, { isFetching: true });
    case RECEIVE_CSV:
      return Object.assign({}, state, reportsInit, action.payload);
    case ERROR_CSV:
      return Object.assign({}, state, reportsInit, action.payload);
    case CLEAR_ERROR_OR_DATA:
      return Object.assign({}, state, {
        isFetching: false,
        objectBlob: null,
        error: null,
        topic: null
      });
    case INITIATED_EXPORT_PARTICIPANT_ARCHIVE:
      return Object.assign({}, state, { initiatedParticipantExport: true, exportStudy: action.payload });
    case RESET_INITIATED_EXPORT_PARTICIPANT_ARCHIVE:
      return Object.assign({}, state, { initiatedParticipantExport: false, exportStudy: null });
    case RESET_INITIATED_EXPORT_PARTICIPANT_ARCHIVE:
      return Object.assign({}, state, { initiatedParticipantExport: false, exportStudy: null });
    case GET_EXPORT_ARCHIVE_STATUS:
      return Object.assign({}, state, { newDataAvailableForExport: action.payload });
    case GET_EXPORT_ARCHIVE_STATUS_ERROR:
      return Object.assign({}, state, { newDataAvailableForExport: null });
    default:
      return state;
  }
};

export default reportsReducer;
